module.exports = __webpack_public_path__ + "img/aanleg3.d33b0cc3.jpg";